import React from "react";
import "./ConsentJourneyPhones.css";

const FIU_LABEL = "Your FIU";

const AppBar: React.FC<{ showBack?: boolean; showClose?: boolean }> = ({
  showBack,
  showClose = true,
}) => (
  <div className="cj-appbar">
    {showBack && <span className="cj-back">←</span>}
    <span className="cj-logo">FIU</span>
    <span className="cj-title">{FIU_LABEL}</span>
    <span className="cj-lang">Aa/अ</span>
    {showClose && <span className="cj-close">✕</span>}
  </div>
);

const FinvuFooter: React.FC = () => (
  <div className="cj-footer-finvu">
    Powered by RBI-Regulated AA <span className="cj-finvu-mark">◆ FINVU</span>
  </div>
);

const FooterNote: React.FC = () => (
  <div className="cj-footer-note">
    ⓘ You can pause or cancel sharing anytime via the Finvu app
  </div>
);

export const OtpScreen: React.FC = () => (
  <div className="cj-phone">
    <AppBar />
    <div className="cj-body">
      <h2 className="cj-screen-h cj-screen-h--tight">
        {FIU_LABEL} uses Finvu to safely receive your financial details
      </h2>
      <p className="cj-sub">Please enter the OTP sent by Finvu on ******7496</p>

      <div className="cj-otp-row">
        {Array.from({ length: 6 }).map((_, i) => (
          <div key={i} className="cj-otp-box" />
        ))}
      </div>
      <div className="cj-otp-resend">Didn't receive OTP? Try Again in 22 sec</div>

      <div className="cj-info-card">
        <div className="cj-info-head">
          ⓘ Joint account holders are not supported at this time
        </div>
        <div className="cj-info-row">
          <span className="cj-ico">👥</span>
          <span>
            <b>10 Million+</b> users have used Account Aggregators (AAs)!
          </span>
        </div>
        <div className="cj-info-row">
          <span className="cj-ico">🏛</span>
          <span>
            Supported by:
            <span className="cj-supported-logos">
              <span className="cj-mini cj-bi-hdfc" />
              <span className="cj-mini cj-bi-icici">i</span>
              <span className="cj-mini cj-mini-axis">A</span>
              <span className="cj-mini cj-bi-sbi" />
            </span>{" "}
            + 30 others
          </span>
        </div>
      </div>

      <div className="cj-bottom">
        <div className="cj-btn cj-disabled">Verify &amp; Proceed</div>
        <div className="cj-terms-foot">
          By clicking "Verify &amp; Proceed" you agree to
          <br />
          <span className="cj-terms-link">Finvu's Terms and Conditions</span>
        </div>
        <FinvuFooter />
      </div>
    </div>
  </div>
);

export const DiscoveryScreen: React.FC = () => (
  <div className="cj-phone">
    <AppBar />
    <div className="cj-body">
      <h2 className="cj-screen-h">Select Accounts</h2>
      <p className="cj-sub">Choose the accounts you want to share</p>

      <div className="cj-tabs">
        <div className="cj-tab cj-active">🏛 Banks</div>
        <div className="cj-tab">
          📈 Investments <span className="cj-check-dot">✓</span>
        </div>
        <div className="cj-tab">🧾 GSTR</div>
      </div>

      <div className="cj-bank-prompt">Select your bank(s)</div>
      <div className="cj-search">
        🔍 <span>Search by bank name</span>
      </div>

      <div className="cj-sec-h">
        <span className="cj-lbl">3 selected</span>
        <span className="cj-clear">Clear all</span>
      </div>

      <div className="cj-group-title">Most picked</div>
      <div className="cj-bank-row cj-selected">
        <span className="cj-ic">
          <span className="cj-bank-icon cj-bi-hdfc" />
        </span>{" "}
        HDFC Bank
      </div>
      <div className="cj-bank-row cj-selected">
        <span className="cj-ic">
          <span className="cj-bank-icon cj-bi-icici">i</span>
        </span>{" "}
        ICICI Bank
      </div>
      <div className="cj-bank-row">
        <span className="cj-ic">
          <span className="cj-bank-icon cj-bi-sbi" />
        </span>{" "}
        STATE BANK OF INDIA
      </div>

      <div className="cj-group-title cj-group-title--spaced">
        All information providers
      </div>
      <div className="cj-bank-row">
        <span className="cj-ic cj-bi-assam">A</span> Assam Gramin Vikash Bank
      </div>
      <div className="cj-bank-row">
        <span className="cj-ic cj-bi-apg">APG</span> Andhra Pradesh Gramin Vikas Bank
      </div>

      <FooterNote />
      <div className="cj-btn">Continue</div>
      <FinvuFooter />
    </div>
  </div>
);

export const LinkingScreen: React.FC = () => (
  <div className="cj-phone">
    <AppBar />
    <div className="cj-body">
      <h2 className="cj-screen-h">Select Accounts</h2>
      <p className="cj-sub">Choose the accounts you want to share</p>

      <div className="cj-tabs">
        <div className="cj-tab cj-active">🏛 Banks</div>
        <div className="cj-tab">📈 Investments</div>
        <div className="cj-tab">🧾 GSTR</div>
      </div>

      <div className="cj-sec-h">
        <div>
          <div className="cj-sec-h-title">Banks</div>
          <div className="cj-lbl">Bank accounts</div>
        </div>
        <div className="cj-sec-h-count">4 of 4 selected</div>
      </div>

      <div className="cj-acct-group">
        <div className="cj-acct-bank">
          <span className="cj-bank-icon cj-bank-icon--lg cj-bi-bom" /> Bank of
          Maharashtra
        </div>
        <div className="cj-acct-line">
          <div className="cj-left">Savings Account · xx8376</div>
          <div className="cj-acct-status">
            <span className="cj-linked">🔗 Linked</span>
            <span className="cj-check-box">✓</span>
          </div>
        </div>
      </div>

      <div className="cj-acct-group">
        <div className="cj-acct-bank">
          <span className="cj-bank-icon cj-bank-icon--lg cj-bi-hdfc" /> HDFC Bank
        </div>
        <div className="cj-acct-line">
          <div className="cj-left">Savings Account · xx2190</div>
          <div className="cj-acct-status">
            <span className="cj-linked">🔗 Linked</span>
            <span className="cj-check-box">✓</span>
          </div>
        </div>
        <div className="cj-acct-line">
          <div className="cj-left">Savings Account · xx9291</div>
          <div className="cj-acct-status">
            <span className="cj-linked">🔗 Linked</span>
            <span className="cj-check-box">✓</span>
          </div>
        </div>
      </div>

      <div className="cj-acct-group">
        <div className="cj-acct-bank">
          <span className="cj-bank-icon cj-bank-icon--lg cj-bi-icici">i</span>{" "}
          ICICI Bank
        </div>
        <div className="cj-acct-line">
          <div className="cj-left">Savings Account · xx7879</div>
          <div className="cj-acct-status">
            <span className="cj-linked">🔗 Linked</span>
            <span className="cj-check-box">✓</span>
          </div>
        </div>
      </div>

      <div className="cj-add-more">
        <span>Missing any accounts?</span>
        <span className="cj-right">Add more accounts +</span>
      </div>

      <FooterNote />
      <div className="cj-btn">Continue</div>
      <FinvuFooter />
    </div>
  </div>
);

export const ReviewScreen: React.FC = () => (
  <div className="cj-phone">
    <AppBar showBack />
    <div className="cj-body">
      <h2 className="cj-screen-h">One last check!</h2>
      <p className="cj-sub">
        Review how {FIU_LABEL} will be using your financial details
      </p>

      <div className="cj-card">
        <div className="cj-card-h">
          <h3>Accounts being shared</h3>
          <span className="cj-link">Manage</span>
        </div>
        <div className="cj-banks-label">Banks</div>
        <div className="cj-banks-row">
          <span className="cj-bank-chip">
            <span className="cj-bank-icon cj-bi-bom" /> · 8376
          </span>
          <span className="cj-bank-chip">
            <span className="cj-bank-icon cj-bi-hdfc" /> · 9291
          </span>
          <span className="cj-bank-chip">
            <span className="cj-bank-icon cj-bi-hdfc" /> · 2190
          </span>
        </div>
      </div>

      <div className="cj-card">
        <div className="cj-row">
          <span className="cj-ico">🔍</span>
          <div>
            <div className="cj-lbl">How your data will be used</div>
            <div className="cj-val">Aggregated statement</div>
          </div>
          <span className="cj-link cj-right">View</span>
        </div>
        <div className="cj-row">
          <span className="cj-ico">⏱</span>
          <div>
            <div className="cj-lbl">How often data is accessed</div>
            <div className="cj-val">ONETIME</div>
          </div>
        </div>
        <div className="cj-row">
          <span className="cj-ico">📅</span>
          <div>
            <div className="cj-lbl">Access valid till</div>
            <div className="cj-val">19 Apr 2025 to 19 Jun 2026</div>
          </div>
        </div>
        <div className="cj-row">
          <span className="cj-ico">🗂</span>
          <div>
            <div className="cj-lbl">How long it's used</div>
            <div className="cj-val">1 Month</div>
          </div>
        </div>
      </div>

      <div className="cj-add-more">
        <span>Missing any accounts?</span>
        <span className="cj-right">Add more accounts +</span>
      </div>

      <FooterNote />
      <div className="cj-btn">Give permission</div>
      <div className="cj-btn-link">Decline</div>
      <FinvuFooter />
    </div>
  </div>
);

export const SuccessScreen: React.FC = () => (
  <div className="cj-phone">
    <div className="cj-appbar">
      <span className="cj-logo">FIU</span>
      <span className="cj-title">{FIU_LABEL}</span>
      <span className="cj-lang">Aa/अ</span>
    </div>
    <div className="cj-success-wrap">
      <div className="cj-check-ring">
        <div className="cj-check-circle">
          <div className="cj-check-mark" />
        </div>
      </div>
      <p className="cj-success-msg">
        You have successfully shared your accounts with {FIU_LABEL}
      </p>
      <div className="cj-acct-chips">
        <span className="cj-item">
          <span className="cj-bank-icon cj-bi-bom" /> · 8376
        </span>
        <span className="cj-item">
          <span className="cj-bank-icon cj-bi-hdfc" /> · 9291
        </span>
        <span className="cj-item">
          <span className="cj-bank-icon cj-bi-hdfc" /> · 2190
        </span>
      </div>
      <div className="cj-pill-info">
        ⓘ You can pause or cancel sharing anytime via the Finvu app
      </div>
    </div>
    <div className="cj-success-spacer" />
    <div className="cj-appbar cj-appbar--footer">
      <span className="cj-logo">FIU</span>
      <span className="cj-fiu-label">{FIU_LABEL}</span>
    </div>
  </div>
);
